import styled, { css } from 'styled-components'
import ReactMarkdown from 'react-markdown'

export const Shadow = css`
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
`

export const Radius = css`
    border-radius: 0.2rem;
`

export const StyledReactMarkdown = styled(ReactMarkdown)`
    font-size: ${props => props.fontsize};

    h1 {
        font-size: 1.8em;
        font-weight: 400;
        margin-top: 2rem;
        margin-bottom: 2rem;
    }

    h1:first-child {
        margin-top: 0;
    }

    h2 {
        font-size: 1.3em;
        font-weight: 400;
        margin-top: 2rem;
        margin-bottom: 1rem;
    }

    h3 {
        font-size: 1em;
        margin-top: 2rem;
        margin-bottom: 1rem;
    }

    ul {
        margin: 0;
    }
`



// WEBPACK FOOTER //
// ./src/styles.js